// Check in the future to see if it's better to use it in theme/overrides and if it doesn't break the layout

export const inputSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px !important'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '8px !important'
  }
};
